module.exports = __webpack_public_path__ + "img/五星乡-c.616515d1.png";